import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import moment from 'moment'

class AddStoreBlockDate extends React.Component {
    state = {
        date: new Date(),
        isData: false,
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    }

    addBlockDate = () => {
        var that = this
        var dateDMY = moment(this.state.date).format('YYYY-MM-DD')

        var data = {
            reference_id: this.props.storeId,
            date: dateDMY,
        }

        this.setState({ isData: true })
        axios
            .post(Constant.getAPI() + `/store/create-store-block-date`, data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                    country_short_name: `${localStorage.getItem('countryShortName')}`,
                },
            })
            .then((res) => {
                that.setState({ isData: false })
                if (res.status) {
                    Swal.fire({
                        title: 'Block Date Added Successfully!',
                        icon: 'success',
                        text: '',
                        type: 'success',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ok',
                    })
                }
                window.location.href = `#/store-details/${this.props.storeId}/store-block-date-lists`
            })
            .catch((err) => {
                this.setState({ isData: false })
                if (err?.response?.status === 401) {
                    Constant.getAuthLogout()
                } else {
                    Swal.fire({
                        title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                        icon: 'error',
                        text: '',
                        type: 'error',
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ok',
                    })
                }
            })
    }

    render() {
        return (
            <div className="">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group row">
                                <label className="col-sm-3 col-form-label">Date</label>
                                <div className="col-sm-9">
                                    <input
                                        type="date"
                                        id="date"
                                        name="date"
                                        className="form-control"
                                        onChange={this.handleChange}
                                        value={this.state.date}
                                        min={new Date().toISOString().split('T')[0]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="text-right col-6 offset-6">
                                <Link
                                    to={`/store-details/${this.props.storeId}/store-block-date-lists`}
                                    className="btn btn-outline-secondary m-2 "
                                >
                                    <i className="icofont icofont-rounded-double-left"></i>
                                    Back
                                </Link>
                                {this.state.isData ? (
                                    <button
                                        className="btn hor-grd btn-grd-inverse offset-1"
                                        disabled
                                    >
                                        Saving...!
                                    </button>
                                ) : (
                                    <button
                                        onClick={this.addBlockDate}
                                        className="btn hor-grd btn-grd-inverse offset-1"
                                    >
                                        <i className="ti-save"></i>Save
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AddStoreBlockDate
